// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"514":"assets/themes/svp/css/app.fe","547":"assets/themes/svp/css/mail/default","870":"assets/themes/svp/css/app.be"}[chunkId] + ".css";
};